import React from 'react';
import FavoritesSystem from '@/components/course/FavoritesSystem';
import EnhancedBreadcrumbNavigation from '@/components/course/EnhancedBreadcrumbNavigation';

const FavoritesPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-background">
      <EnhancedBreadcrumbNavigation />
      <div className="container mx-auto py-8">
        <FavoritesSystem />
      </div>
    </div>
  );
};

export default FavoritesPage;